import React from 'react'
import queryString from 'query-string'
import { useConfig, usePayment } from 'hooks'
import { Message } from 'components/@common/Message'
import TimerBanner from 'components/TimerBanner'
import PriceBreakdown from 'components/PriceBreakdown'
import Addons from 'components/Addons'
import useOptimizelyExperiment from 'hooks/experiments/useOptimizelyExperiment'
import { ReactSDKClient, withOptimizely } from '@optimizely/react-sdk'
import { addMissingUtmTags } from '../../../history'
import {
  LegalText,
  PaymentHeader,
  BoldLegalText,
  AddonsWrapper,
  StyledLink,
} from './PaymentContent.styles'
import Small from 'components/@common/Small'

interface PaymentContentProps {
  optimizely: ReactSDKClient | null
}

const PaymentContent: React.FC<PaymentContentProps> = ({ optimizely }) => {
  const shouldUseSplitAddonsPage = useOptimizelyExperiment(
    optimizely,
    'addons_page',
    'page_enabled',
  )
  const config = useConfig()
  const { payment } = usePayment()
  const parsedQueryString = queryString.parse(window.location.search)
  let error: string | null = null
  if (parsedQueryString.message) {
    error = parsedQueryString.message as string
  }

  // eslint-disable-next-line no-new-object
  const queries = addMissingUtmTags(new Object(null))

  return (
    <>
      <PaymentHeader>Payment</PaymentHeader>
      {!shouldUseSplitAddonsPage && (
        <AddonsWrapper>
          <Addons />
        </AddonsWrapper>
      )}
      {!payment.priceMatch && (
        <Message heading='We are sorry, your price has now updated' type='info'>
          Please double check before proceeding
        </Message>
      )}
      {payment.paymentError && (
        <Message heading='Payment Error' type='error'>
          {payment.paymentError}
        </Message>
      )}
      {error && (
        <Message heading='Payment Error' type='error'>
          {error}
        </Message>
      )}
      <TimerBanner />
      <BoldLegalText>
        Our prices can update on the hour. If your price is updated, we'll show
        you your new price before you buy.
      </BoldLegalText>
      <PriceBreakdown />
      <Small>
        The Tempcover fee is payable under your separate Tempcover contract for
        administering your policy. Once purchased, you cannot change any details
        and no refunds are available under our{' '}
        <StyledLink
          href={queryString.stringifyUrl({
            url: `${config.SITE_URL}/our-refund-policy`,
            query: { ...queries },
          })}
          target='_blank'
          rel='noopener noreferrer'
          id='refundPolicyLnk'
        >
          refund policy
        </StyledLink>
        .
      </Small>
    </>
  )
}

export default withOptimizely(PaymentContent)
